import { ICONS } from "../../../general-components/icon";
import { SelectGroupOption } from "../../../general-components/select-group";

export enum animationTiming {
	immediate = 'on-shot-transition',
	delayed = 'after-delay',
	manual = 'manual'
}

export type animateOption = {
	label:  string,
	value: animationTiming
}

export const animateInOptions: animateOption[] = [
	{ label: 'When shot starts', value: animationTiming.immediate },
	{ label: 'After shot starts', value: animationTiming.delayed },
	{ label: 'When I manually decide', value: animationTiming.manual },
]

// THE ORDER OF THESE IS VERY IMPORTANT
// The front end sends the *index* of the selected animation in the
// graphics .animation property (don't kill the messenger)
export const transitionEffects: SelectGroupOption[] = [
	{ label: 'When shot starts', value: 'on-shot-transition' },
	{ label: 'Manual', value: 'manual' },
	{ label: 'After delay', value: 'after-delay' },
];

export const transitionOutEffects: SelectGroupOption[] = [
	{ label: 'Manual', value: 'manual' },
	{ label: 'After delay', value: 'after-delay' },
];

export const animationOptions: SelectGroupOption[] = [
	{ label: 'None', value: 'none' },
	{ label: 'Dissolve', value: 'dissolve', icon: ICONS.ANIMATION_DISSOLVE },
	{ label: 'Move In', value: 'move-in', icon: ICONS.ANIMATION_MOVE_OUT},
];

export const animationOutOptions: SelectGroupOption[] = [
	{ label: 'None', value: 'none' },
	{ label: 'Dissolve', value: 'dissolve', icon: ICONS.ANIMATION_DISSOLVE },
	{ label: 'Move Out', value: 'move-in', icon: ICONS.ANIMATION_MOVE_OUT },
];

export const durationOptions: SelectGroupOption[] = [
	{ label: '250 ms.', value: 0.25 },
	{ label: '500 ms.', value: 0.5 },
	{ label: '1 sec.', value: 1.0 },
	{ label: '5 sec.', value: 5.0 },
	{ label: '10 sec.', value: 10.0 },
];

export const directionals = [
	'move-in',
];